module.exports = __webpack_public_path__ + "media/react/assets/magoosh-logo-white-8450e00ad89508e6d39c86ff2dc7c62f.png";